/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TRemoveOffersFromFolderModel,
  IRemoveOffersFromFolderRequest,
  IMappers,
  IRemoveOffersFromFolderResponse,
  IRemoveOffersFromFolderResponseError,
  TRemoveOffersFromFolderResponse,
} from './types';

const defaultConfig: TRemoveOffersFromFolderModel = {
  apiType: 'public',
  assertStatusCodes: [400, 200, 204],
  method: 'POST',
  microserviceName: 'favorites',
  pathApi: '/v1/remove-offers-from-folder/',
  hostType: 'api',
} as TRemoveOffersFromFolderModel;

function createRemoveOffersFromFolderModel(parameters: IRemoveOffersFromFolderRequest): TRemoveOffersFromFolderModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IRemoveOffersFromFolderOptions<TResponse400, TResponse200, TResponse204> {
  httpApi: IHttpApi;
  parameters: IRemoveOffersFromFolderRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse400, TResponse200, TResponse204>;
}

async function fetchRemoveOffersFromFolder<TResponse400, TResponse200, TResponse204>({
  httpApi,
  parameters,
  config,
  mappers,
}: IRemoveOffersFromFolderOptions<TResponse400, TResponse200, TResponse204>): Promise<
  TResponse400 | TResponse200 | TResponse204 | TRemoveOffersFromFolderResponse
> {
  const { response, statusCode } = await httpApi.fetch(createRemoveOffersFromFolderModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 400) {
      return mappers[400](response as IRemoveOffersFromFolderResponseError);
    }

    if (statusCode === 200) {
      return mappers[200](response as IRemoveOffersFromFolderResponse);
    }

    if (statusCode === 204) {
      return mappers[204]();
    }
  }

  return { response, statusCode } as TRemoveOffersFromFolderResponse;
}

export { defaultConfig, createRemoveOffersFromFolderModel, fetchRemoveOffersFromFolder };
